import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from '../Variable'

export const StepsStyle = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: ${rem(3)} solid ${({ theme }) => theme.color.grayFour};
	margin: ${rem(30, 30)};
	max-height: ${rem(53)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			border-bottom: ${rem(1)} solid
				${({ theme }) => theme.color.grayFour};
		`}

	@media (${device.tablet}) {
		margin: ${rem(10, 30)};
		border-bottom: 0;
	}

	@media (${device.mobileL}) {
		margin: ${rem(-17, 15, 0, 15)};
	}
`
export const Step = styled.div`
	flex-grow: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: ${rem(10, 0)};
	font-weight: 600;
	font-size: ${rem(18)};
	line-height: ${rem(25)};
	letter-spacing: 0.225px;
	color: ${({ theme }) => theme.color.blackOne};
	cursor: default;
	position: relative;
	white-space: nowrap;
	transition: all 0.3s;

	${(p) =>
		p.theme.name === merchantThemes.musto &&
		p.status &&
		css`
			color: ${({ theme }) => theme.color.tertiary};
		`}

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}
		
	${(p) =>
		p.isSingle &&
		css`
			flex-grow: 1;
			justify-content: center;
		`}
	
	&::before {
		text-indent: 0;
		content: attr(data-step);
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: ${rem(16)};
		color: ${({ theme }) => theme.color.graySix};
		width: ${rem(30)};
		flex: 0 0 ${rem(30)};
		height: ${rem(30)};
		border-radius: 50%;
		margin-right: ${rem(11)};
		font-weight: 700;
		background-color: ${({ theme }) => theme.color.grayFive};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-weight: normal;
				background-color: transparent;
				color: ${({ theme }) => theme.color.primary};
				font-size: ${rem(15)};
				letter-spacing: ${rem(0.06)};
				line-height: ${rem(20)};
			`}

		${(props) =>
			props.status &&
			css`
				background-color: ${({ theme }) => theme.color.primary};
				color: ${({ theme }) => theme.color.secondary};

				${(p) =>
					p.theme.name === merchantThemes.toteme &&
					css`
						background-color: transparent;
						color: ${({ theme }) => theme.color.primary};
						border: ${rem(1)} solid
							${({ theme }) => theme.color.primary};
						opacity: 1;
					`}
			`}
		${(p) =>
			p.theme.name === merchantThemes.musto &&
			p.status &&
			css`
				background-color: ${({ theme }) => theme.color.tertiary};
				color: ${({ theme }) => theme.color.secondary};
			`}
	}
	&::after {
		content: none;
		position: absolute;
		height: ${rem(3)};
		width: 100%;
		background-color: ${({ theme }) => theme.color.primary};
		top: 100%;
		left: 0;

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				height: ${rem(1)};
			`}

		${(props) =>
			props.status &&
			css`
				content: '';
			`}
		${(p) =>
			p.theme.name === merchantThemes.musto &&
			css`
				background-color: ${({ theme }) => theme.color.tertiary};
			`}
	}
	@media (${device.tablet}) {
		max-width: ${rem(30)};
		flex-grow: 0;
		justify-content: flex-start;
		overflow: hidden;
		${(props) =>
			props.status &&
			css`
				max-width: 100%;
			`}
		${(p) =>
			p.isSingle &&
			css`
				flex-grow: 1;
				justify-content: center;
			`}
	}
`
